module.exports = __webpack_public_path__ + "img/preview.cde5fd79.jpg";